import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { IconComponent } from './icon.component';

@Component({
  selector: 'app-alert-label',
  imports: [CommonModule, IconComponent, TooltipModule],
  template: `
    <div
      class="alert-tag tw-flex tw-items-center tw-gap-2 tw-p-2 tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-border tw-pr-4"
      [title]="title"
      role="img"
      [attr.aria-label]="ariaLabelText"
      tabindex="0"
    >
      <div
        class="alert-tag-icon tw-rounded-full tw-size-7 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
        aria-hidden="true"
      >
        <app-icon [name]="icon"></app-icon>
      </div>
      <span
        class="alert-tag-text tw-font-bold"
        [title]="title"
        aria-hidden="true"
        >{{ label }}</span
      >
    </div>
  `,
  styles: [
    `
      .alert-label {
        display: flex;
        align-items: center;
      }
      .icon {
        margin-right: 8px;
      }
      .label {
        font-weight: bold;
        margin-right: 8px;
      }
      .title {
        color: #888;
      }
      @media (max-width: 768px) {
        :host {
          display: block;
          min-width: 0;
          max-width: 100%;
        }
        :host .alert-tag {
          flex-wrap: nowrap;
          align-items: center;
          min-width: 0;
          max-width: 100%;
        }
        :host .alert-tag-icon {
          flex-shrink: 0;
        }
        :host .alert-tag-text {
          min-width: 0;
          white-space: normal;
          overflow-wrap: break-word;
        }
      }
    `,
  ],
})
export class AlertLabelComponent {
  @Input({ required: true })
  label: string;

  /**
   * Set to font awesome icon. Exmaple: "fa-solid fa-gavel"
   */
  @Input({ required: true })
  icon: string;

  @Input()
  title = '';

  @Input()
  ariaLabel: string;

  get ariaLabelText(): string {
    if (this.ariaLabel) {
      return this.ariaLabel;
    }
    return this.title
      ? `${this.label} flag: ${this.title}`
      : `${this.label} flag`;
  }
}
